<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Dados de Contato' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-list>
    <ion-item class="top">
      <ion-avatar slot="start">
        <img [src]="pessoa.foto | image:' '" class="avatar-image" />
      </ion-avatar>

      <ion-label>
        <h2>{{pessoa.nome}}</h2>
        <p>{{'Participante' | translate}}</p>
      </ion-label>
    </ion-item>
    <div class="linha-horizontal"></div>
  </ion-list>

  <ion-card-content>
    <ion-list>
      <ion-item class="top">
        <ion-note slot="start" class="icon-dados">
          <i class="fa-solid fa-phone"></i>
        </ion-note>

        <ion-label>
          <p style="display: flex; align-items: center;">
            <a *ngIf="pessoa.telCelular" href="tel:{{pessoa.telCelular}}">
              {{pessoa.telCelular | phone:pessoa.ddiTelCelular }}
            </a>
            <ion-icon
              *ngIf="pessoa.telCelular"
              (click)="abrirLink()"
              style="font-size: 20px; margin-left: 5px; color: #26d366"
              name="logo-whatsapp"
            >
            </ion-icon>
            <span *ngIf="!pessoa.telCelular">{{"Não Informado" | translate}}</span>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <ion-list>
      <ion-item class="top">
        <ion-note slot="start" class="icon-dados">
          <i class="fa-solid fa-envelope"></i>
        </ion-note>

        <ion-label>
          <p>
            <a href="mailto:{{pessoa.email}}" *ngIf="pessoa.email"> {{pessoa.email}} </a>
            <span *ngIf="!pessoa.email">{{"Não Informado" | translate}}</span>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <ion-list>
      <ion-item class="top">
        <ion-note slot="start" class="icon-dados">
          <i class="fa-solid fa-location-arrow"></i>
        </ion-note>

        <ion-label>
          <p style="white-space: break-spaces">{{pessoa.endereco ? pessoa.endereco : ('Não Informado' | translate)}}</p>
        </ion-label>
      </ion-item>
    </ion-list>

    <div *ngIf="pessoa.endereco">
      <a href="http://maps.google.com/?q={{pessoa.endereco}}">
        <div class="down" style="padding-bottom: 25px !important">
          <ion-button expand="block" class="btn-default"> {{'Como Chegar?' | translate}} </ion-button>
        </div>
      </a>
    </div>
  </ion-card-content>
</ion-content>
